export default {
  async getBlogItems(options) {
    try {
      // TODO SEARCH BLOG BY CATEGORY
      const { data } = await useApi('/api/blogs/', options)
      return data
    }
    catch (error) {
      return [error]
    }
  },
  async getBlogItem(slug) {
    try {
      const response = await useApi(`/api/blogs/${slug}`)
      return response
    }
    catch (error) {
      return error
    }
  },
  async getBlogCategories() {
    try {
      const { data } = await useApi('/api/blogs/categories')
      return data
    }
    catch (error) {
      return [error]
    }
  },
}
